<template>
    <ItemIndex
        :singular-name="singularName"
        :plural-name="pluralName"
        :item-type="indexType"
    >
        <ItemIndexFilterNotification
            :index-type="indexType"
            :show="filter.show"
            :type="filter.type"
            :term="filter.term"
        />
        <v-data-table
            :search="searchTerm"
            :headers="headers"
            :items="items"
            :items-per-page="10"
            :loading="tableLoading"
        >
            <template #item.name="{ item }">
                <v-btn
                    x-small
                    :to="'/section/edit/' + item.id"
                    color="primary"
                >
                    {{ item.name }}
                    <v-icon
                        right
                        x-small
                    >
                        fas fa-edit
                    </v-icon>
                </v-btn>
            </template>
            <template #item.step.name="{ item }">
                <span v-if="item.step">
                    <v-btn
                        type="button"
                        x-small
                        color="secondary"
                        @click="filterIndex('Step', item)"
                    >
                        {{ item.step.name }}
                    </v-btn>
                </span>
            </template>
            <template #item.published="{ item }">
                <v-icon
                    small
                    color="primary"
                    v-if="item.published === 1"
                >
                    fas fa-check-circle
                </v-icon>
                <v-icon
                    small
                    color="error"
                    v-else
                >
                    fas fa-minus-circle
                </v-icon>
            </template>
        </v-data-table>
    </ItemIndex>
</template>

<script>
import ItemIndexBoilerplate from '@/views/Admin/Config/Commonn/ItemIndexBoilerplate';

export default {
    mixins: [ ItemIndexBoilerplate ],

    data() {
        return {
            indexType: 'section',
            singularName: 'Section',
            pluralName: 'Sections',
            responseObject: 'sections',
            headers: [
                {
                    text: 'Name',
                    value: 'name',
                },
                {
                    text: 'Step',
                    value: 'step.name',
                },
                {
                    text: 'Level',
                    value: 'level'
                },
                {
                    text: 'Order',
                    value: 'order',
                },
                {
                    text: 'Published',
                    value: 'published',
                    align: 'right',
                },
            ],
        };
    }
};
</script>
